import { paginatedQuery } from 'lib-shared-api-utils';
import { api } from 'utils/apis/api';
export const usersApi = api.injectEndpoints({
    endpoints: (builder) => ({
        createUser: builder.mutation({
            query: (data) => ({
                version: 1,
                path: 'users',
                method: 'POST',
                data,
            }),
        }),
        readUser: builder.query({
            query: ({ id }) => ({
                version: 1,
                path: `users/${id}`,
            }),
        }),
        updateUser: builder.mutation({
            query: ({ id, patch: body }) => ({
                version: 1,
                path: `users/${id}`,
                method: 'PATCH',
                body,
            }),
        }),
        readUsers: builder.query({
            query: ({ limit, userRole }) => ({
                version: 1,
                path: 'users',
                params: Object.assign({ limit }, (userRole && { [userRole]: true })),
            }),
        }),
        readAgents: builder.query({
            query: (arg) => paginatedQuery(arg, ({ teamId: filter_out_by_team, queueId: filter_out_by_queue }) => ({
                version: 1,
                path: 'users/agents',
                params: {
                    filter_out_by_team,
                    filter_out_by_queue,
                },
            })),
        }),
    }),
});
